import { fetch } from '@atlassian/eoc-fetch';
import { withAIOpsDomainPrefix } from '../../../../common/utils';
export const getCompressionRatio = () => {
  return fetch(withAIOpsDomainPrefix('/v1/alert-insights/compression-ratio'), {
    exactUrl: true
  });
};